import { computed } from 'vue';
import { useAppState } from '@/composables/useAppState';
export function useDarkMode() {
    const state = useAppState();
    const isDarkMode = computed(() => state.isDarkMode);
    return { isDarkMode };
}
